type DollarValue = {
  value: number
  timestamp: string
}

let socket: WebSocket | null = null
let listeners: Array<(data: DollarValue) => void> = []
let openListeners: Array<() => void> = []
let reconnectAttempts = 0
const MAX_RECONNECT_ATTEMPTS = 10

function connectWebSocket(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    function connect() {
      socket = new WebSocket(url)

      socket.onopen = () => {
        console.log('WebSocket conectado')
        reconnectAttempts = 0
        openListeners.forEach(cb => cb())
        resolve()
      }

      socket.onerror = (error) => {
        console.error('Error en WebSocket:', error)
        if (reconnectAttempts < MAX_RECONNECT_ATTEMPTS) {
          reconnectAttempts++
          const timeout = Math.min(1000 * 2 ** reconnectAttempts, 30000)
          setTimeout(connect, timeout)
        } else {
          reject(error)
        }
      }

      socket.onclose = () => {
        console.warn('WebSocket desconectado.')
        if (reconnectAttempts < MAX_RECONNECT_ATTEMPTS) {
          reconnectAttempts++
          const timeout = Math.min(1000 * 2 ** reconnectAttempts, 30000)
          setTimeout(connect, timeout)
        }
      }

      socket.onmessage = (event) => {
        try {
          // Validar si el mensaje es JSON
          if (typeof event.data === 'string' && event.data.trim().startsWith('{')) {
            const data: DollarValue = JSON.parse(event.data)
            listeners.forEach((cb) => cb(data))
          } else {
            console.warn('Mensaje recibido no es JSON:', event.data)
          }
        } catch (e) {
          console.error('Error al parsear mensaje:', e)
        }
      }
    }

    connect()
  })
}

function onMessage(callback: (data: DollarValue) => void) {
  listeners.push(callback)
}

function removeMessageListener(callback: (data: DollarValue) => void) {
  listeners = listeners.filter((cb) => cb !== callback)
}

function sendMessage(data: any) {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(data))
  } else {
    console.warn('No se puede enviar el mensaje: WebSocket no conectado.')
  }
}

function closeWebSocket() {
  if (socket && socket.readyState !== WebSocket.CLOSED) {
    socket.close()
    socket = null
    listeners = []
    openListeners = []
    reconnectAttempts = 0
  }
}

export { connectWebSocket, onMessage, removeMessageListener, sendMessage, closeWebSocket }